import { InputHelperText } from '@/shared/components/input-helper-text'
import { PhoneNumberInput } from '@/shared/components/phone-number-input'
import { UserRoleSelector } from '@/shared/selectors'

const { DocumentNumberInput } = require('@/components/document-number-input')
const { GroupInput } = require('@/components/v2/group-input')
const { Input, Checkbox } = require('@material-tailwind/react')
const { useFormikContext } = require('formik')
const { useTranslation } = require('react-i18next')

export const UserPersonalInformationForm = (props) => {
  const { setSelectedRole } = props
  const { t } = useTranslation()
  const { values, handleChange, errors, setFieldValue, validateForm } = useFormikContext()

  const onUserRoleChange = async (option = {}) => {
    if (!option?.value) {
      setSelectedRole({})
      await setFieldValue('role_ids', [])
      await validateForm()
      return
    }

    setSelectedRole(option?.resource)
    await setFieldValue('role_ids', [option.value])
    await validateForm()
  }
  return (

    <GroupInput
      title='Datos personales'
      description='Rellena la información del nuevo usuario'
      className='py-8'
    >
      <div className='grid grid-cols-2 gap-4'>
        <Input
          required
          name='first_name'
          label='Nombres'
          value={values.first_name}
          onChange={handleChange}
        />

        <Input
          required
          name='last_name'
          label='Apellidos'
          value={values.last_name}
          onChange={handleChange}
        />

        <div>
          <DocumentNumberInput
            name='document_number'
            label={t('documentNumber.one')}
            value={values.document_number}
            onChange={handleChange}
            error={Boolean(errors.document_number)}
            className='mb-4 grow'
          />
          <InputHelperText label={errors.document_number} color='red' />

          <Checkbox
            name='has_local_document_number'
            ripple={false}
            className='hover:before:opacity-0'
            containerProps={{ className: 'p-0' }}
            labelProps={{ className: 'ml-1' }}
            checked={!values.has_local_document_number}
            onChange={(event) =>
              setFieldValue(
                'has_local_document_number',
                !event.target.checked
              )
            }
            label='No tiene RUT'
          />
        </div>

        <Input
          required
          name='email'
          label={t('email.one')}
          value={values.email}
          onChange={handleChange}
        />

        <PhoneNumberInput
          name='phone'
          label={t('phone.one')}
          value={values.phone}
          onChange={handleChange}
        />

        <div>
          <UserRoleSelector
            required
            onChange={onUserRoleChange}
            value={values.role_ids[0]}
          />
          <InputHelperText label={errors.role_ids} color='red' />
        </div>
      </div>
    </GroupInput>
  )
}
